import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSnackbar,{attrs:{"top":"","right":"","color":"error","value":_vm.show,"timeout":5000},on:{"input":_vm.reset}},[_c(VIcon,{staticClass:"mr-3"},[_vm._v("mdi-alert-circle-outline")]),_vm._v(" "+_vm._s(_vm.$store.state.error.text)+" "),_c(VBtn,{attrs:{"icon":""},on:{"click":_vm.hideError}},[_c(VIcon,[_vm._v("mdi-close")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }